import { Form, InputNumber } from "antd";
import React from "react";

const SubjectWeight: React.FC = () => {
  return (
    <Form.Item name={["subjectMetric", "weight"]} label="Weight (kg)">
      <InputNumber
        controls={false}
        changeOnWheel={false}
        style={{ width: "100%" }}
      />
    </Form.Item>
  );
};

export default SubjectWeight;
